import React from 'react'
import { usePage } from '@/hooks'
import Container from '@/components/Container'
import Title from '@/components/Title'
import style from './styles/games.module.scss'
import HtmlContent from '@/components/HtmlContent'
// import RatingMap from './components/RatingMap'
import GamesList from './components/GamesList'

const Games = (): React.ReactElement => {
  const page = usePage()
  const { object } = page.init_state

  return (
    <Container>
      <Title type='h1' className={style.games__title}>
        {object?.title}
      </Title>
      <HtmlContent content={object.detail} className={style.games__text} />

      <GamesList />

      {/* <RatingMap /> */}
    </Container>
  )
}

export default Games
